import './styles.scss';
import './../Modal/Menu/scripts';

const doLanguageRedirect = (newLocale,) => {
  const locales = ['br', 'en', 'es',];
  const currentUrl = window.location.href;

  if (!locales.includes(newLocale,)) {
    return console.error('Invalid language',);
  }

  let newUrl = currentUrl;
  const localePattern = /\/(br|en|es)(\/|$)/;
  if (!localePattern.test(currentUrl,)) {
    const urlParts = currentUrl.split('/',);
    urlParts.splice(3, 0, newLocale,); 
    newUrl = urlParts.join('/',);
  } else {
    newUrl = currentUrl.replace(localePattern, `/${newLocale}/`,);
  }
  
  localStorage.setItem('dtlaw-lang', newLocale,);
  window.location.replace(newUrl,);
};


window.onload = () => {
  // window.addEventListener('scroll', () => {
  //   const header = document.querySelector('.site-header',);
  //   if (window.scrollY > 88) {
  //     header.classList.add('header--sticky',);
  //   } else {
  //     header.classList.remove('header--sticky',);
  //   }
  // },);

  const language = document.getElementById('language',);
  const languageList = document.getElementById('language-list',);

  if (!language || !languageList) {
    return;
  }

  // lang menu
  document.addEventListener('click', (event,) => {
    if (language.contains(event.target,)) {
      if (languageList.classList.contains('active',)) {
        languageList.classList.remove('active',);
      } else {
        languageList.classList.add('active',);
      }
    } else if (
      !languageList.contains(event.target,) &&
      !language.contains(event.target,)
    ) {
      languageList.classList.remove('active',);
    }

    // toggle share menu
    const share = document.getElementById('share',);
    const shareList = document.getElementById('share-list',);

    if (!share || !shareList) {
      return;
    }

    if (share.contains(event.target,)) {
      if (shareList.classList.contains('active',)) {
        shareList.classList.remove('active',);
      } else {
        shareList.classList.add('active',);
      }
    } else if (
      !shareList.contains(event.target,) &&
      !share.contains(event.target,)
    ) {
      shareList.classList.remove('active',);
    }
  },);

  // if localeStorage has lang
  // const lang = localStorage.getItem('dtlaw-lang',);
  // const wsLang = window.location.pathname.split('/',)[1];
  
  // if (lang && lang !== wsLang) {
  //   doLanguageRedirect(lang,);
  // }

  const languageLinks = document.querySelectorAll('.language-link',);
  if (languageLinks) {  
    languageLinks.forEach((link,) => {
      link.addEventListener('click', (event,) => {
        event.preventDefault();
        const lang = link.dataset.lang;
        doLanguageRedirect(lang,);
      },);
    },);
  }
};
